export type BookingStatusMessage = {
  title?: string;
  text?: string;
};

export const hasBookingStatusMessage = (message?: BookingStatusMessage | null): boolean =>
  Boolean(message?.title?.trim() || message?.text?.trim());
